import Vue from 'vue'
import { format, parseISO } from 'date-fns'
import { es } from 'date-fns/locale'

Vue.filter('formatDateCreated', function (value) {
  if (value) {
    let date = parseISO(String(value).trim())
    return format(date, "d MMM", { locale: es })
  }
})
